import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "p-fluid formgrid grid" }
const _hoisted_5 = { class: "field col-3" }
const _hoisted_6 = {
  key: 0,
  class: "p-error"
}
const _hoisted_7 = { class: "field col-3" }
const _hoisted_8 = { class: "field col-3" }
const _hoisted_9 = { class: "field col-3" }
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", null, [
        _cache[5] || (_cache[5] = _createElementVNode("i", {
          class: "fa fa-exclamation-triangle",
          "aria-hidden": "true"
        }, null, -1 /* HOISTED */)),
        _createTextVNode(" " + _toDisplayString((_ctx.isError ?? false ? 'Error' :'Sugerencia')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", {
              for: "title",
              class: _normalizeClass({ 'p-invalid': _ctx.v$.title.$invalid && _ctx.submitted, 'customrequired': true })
            }, "Título", 2 /* CLASS */),
            _createVNode(_component_InputText, {
              id: "title",
              modelValue: _ctx.data.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.title) = $event)),
              class: _normalizeClass({ 'p-invalid': _ctx.v$.title.$invalid && _ctx.submitted })
            }, null, 8 /* PROPS */, ["modelValue", "class"]),
            ((_ctx.v$.title.$invalid && _ctx.submitted) || _ctx.v$.title.$pending.$response)
              ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.v$.title.required.$message), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { for: "name" }, "Nombre", -1 /* HOISTED */)),
            _createVNode(_component_InputText, {
              id: "name",
              modelValue: _ctx.data.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.name) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { for: "phone" }, "Teléfono", -1 /* HOISTED */)),
            _createVNode(_component_InputText, {
              id: "phone",
              modelValue: _ctx.data.phone,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.phone) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", {
              for: "fechaDesde",
              class: _normalizeClass({ 'p-invalid': _ctx.v$.description.$invalid && _ctx.submitted, 'customrequired': true })
            }, "Por favor, describa la sugerencia de forma detallada:", 2 /* CLASS */),
            _createVNode(_component_Textarea, {
              id: "complementAddress",
              type: "text",
              modelValue: _ctx.data.description,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.description) = $event)),
              autoResize: true,
              rows: "4",
              cols: "30",
              class: _normalizeClass({ 'p-invalid': _ctx.v$.description.$invalid && _ctx.submitted })
            }, null, 8 /* PROPS */, ["modelValue", "class"]),
            ((_ctx.v$.description.$invalid && _ctx.submitted) || _ctx.v$.description.$pending.$response)
              ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.v$.description.required.$message), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createVNode(_component_Toolbar, { class: "mb-4" }, {
          end: _withCtx(() => [
            _createVNode(_component_Button, {
              id: "enviar",
              label: "Enviar",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sendSuggest())),
              icon: "pi pi-send",
              class: "p-button p-component"
            })
          ]),
          _: 1 /* STABLE */
        })
      ])
    ])
  ]))
}